"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionMoveModalCtrl = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const services_1 = require("../../services");
const store_1 = require("../../store");
class CollectionMoveModalCtrl {
    constructor(collections) {
        this.moving = false;
        this.collections = collections;
    }
    moveCollections(departmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (departmentId == null || this.moving) {
                return;
            }
            const collectionsByTag = {};
            for (const collection of this.collections) {
                const tagId = collection.tags.find(t => !(0, core_api_1.isSystemTag)(t));
                if (collectionsByTag[tagId] != null) {
                    collectionsByTag[tagId].push(collection);
                }
                else {
                    collectionsByTag[tagId] = [collection];
                }
            }
            this.setMoving(true);
            for (const tagId of Object.keys(collectionsByTag)) {
                const collectionGroup = collectionsByTag[tagId];
                const tag = store_1.AppStore.Tag.get(tagId);
                yield services_1.Services.Collection.move(collectionGroup, tag.name, departmentId);
            }
            this.setMoving(false);
        });
    }
    setMoving(moving) {
        this.moving = moving;
    }
}
exports.CollectionMoveModalCtrl = CollectionMoveModalCtrl;
tslib_1.__decorate([
    mobx_1.observable
], CollectionMoveModalCtrl.prototype, "tagName", void 0);
tslib_1.__decorate([
    mobx_1.observable
], CollectionMoveModalCtrl.prototype, "moving", void 0);
tslib_1.__decorate([
    mobx_1.action
], CollectionMoveModalCtrl.prototype, "setMoving", null);
//# sourceMappingURL=collection.move.modal.ctrl.js.map